import { Injectable, inject } from '@angular/core';
import { MockConfig } from '@partners/kernel';
import { GLOBAL_SETTINGS, IEnvironmentSettings } from '@partners/settings';

@Injectable({
  providedIn: 'root'
})
export class ShellMockConfig extends MockConfig {
  get environment(): IEnvironmentSettings {
    const { environment } = this._shellConfig;
    return environment;
  }
  get isDevMode(): boolean {
    return this.environment.isMockMode;
  }

  private readonly _shellConfig = inject(GLOBAL_SETTINGS);
}
